import * as React from "react";
import UpdateIcon from "@mui/icons-material/Update";
import Fab from "@mui/material/Fab";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import { useTimeMachine } from "@poseidon/firebase/hooks/useTimeMachine";
import LinearProgress from "@mui/material/LinearProgress";

export const TimeMachine = () => {
  const [open, setOpen] = React.useState(false);
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const { timeMachine, loading, saving, setNow } = useTimeMachine();

  const handleClickOpen = () => {
    setSelectedDate(timeMachine.now);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
    setNow(selectedDate).then(() => {
      setOpen(false);
    });
  };

  const handleChange = (value) => {
    setSelectedDate(new Date(value + " UTC"));
  };
  const handleAddMonth = () => {
    setSelectedDate(
      new Date(
        Date.UTC(
          selectedDate.getFullYear(),
          selectedDate.getMonth() + 1,
          selectedDate.getDate(),
          0,
          0,
          0
        )
      )
    );
  };

  return (
    <>
      <Fab
        onClick={handleClickOpen}
        disabled={!timeMachine}
        title={loading ? "Loading..." : timeMachine?.now?.toLocaleDateString()}
        sx={{ position: "fixed", bottom: 16, left: 16, zIndex: 1200 }}
        color="primary"
        aria-label="add"
      >
        <UpdateIcon />
      </Fab>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Time Machine</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This is a temporary feature to fast forward time so you can see
            schedules progress.
          </DialogContentText>
          <DesktopDatePicker
            label="Current Date"
            inputFormat="dd/MM/yyyy"
            value={selectedDate}
            onChange={handleChange}
            minDate={timeMachine?.now}
            renderInput={(params) => (
              <TextField
                autoFocus
                sx={{ mt: 4 }}
                margin="dense"
                fullWidth
                {...params}
              />
            )}
          />
          <Button
            variant="contained"
            color="secondary"
            sx={{ mt: 2 }}
            onClick={handleAddMonth}
          >
            Add Month
          </Button>
        </DialogContent>
        {saving && <LinearProgress />}
        <DialogActions>
          <Button onClick={handleClose} disabled={saving}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={
              saving || !selectedDate || selectedDate <= timeMachine?.now
            }
          >
            Fast Forward Time
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
